<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    width="500"
  >
    <template v-slot:activator="{ attrs }">
      <AdButton
        v-bind="attrs"
        type="move"
        :hint="$t('edit-tree-structure')"
        list-item
        @click="startEditMode"
      />
    </template>

    <v-card class="treeview-edit-dialog">
      <AdCardTitle dialog>
        {{$t('edit-tree-structure')}}
      </AdCardTitle>

      <v-card-text class="mt-5">
        <Treeview
          :tree.sync="editedTree"
          editable
        />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="stopEditMode"
        >
          {{ $t('cancel') }}
        </v-btn>

        <v-btn
          color="primary"
          text
          @click="saveEditedChanges"
        >
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Treeview from '@/components/Utilities/Treeview/Treeview'

export default {
  name: 'TreeviewEditDialog',

  components: {
    Treeview
  },

  props: {
    tree: {
      type: [Array, Object],
      required: true
    }
  },

  data () {
    return {
      dialog: false,
      editedTree: []
    }
  },
  watch: {
    tree: {
      immediate: true,
      deep: true,
      handler () {
        // Revert tree structure.
        this.revertTreeStructure()
      }
    }
  },

  methods: {
    /**
     * Start edit mode.
     */
    async startEditMode () {
      try {
        // Try to get onBeforeEdit callback.
        const onBeforeEdit = this.tree?.onBeforeEdit || null
        // Check if handler is instance of function.
        if (onBeforeEdit instanceof Function) {
          // Call handler and inject active item.
          const status = await onBeforeEdit(this.editedTree?.items)
          // Set dialog status.
          this.dialog = status === true
        }
      } catch (error) {
        const errorMessage = error?.response?.data?.description || error?.response?.statusText || 'Error'
        this.$oops(errorMessage)
      }
    },

    /**
     * Stop edit mode.
     */
    async stopEditMode () {
      // Revert tree structure.
      await this.revertTreeStructure()
      // Try to get onAfterEdit callback.
      const onAfterEdit = this.tree?.onAfterEdit || null
      // Check if handler is instance of function.
      if (onAfterEdit instanceof Function) {
        // Call handler and inject active item.
        await onAfterEdit(this.editedTree?.items)
      }
    },

    /**
     * Revert tree structure..
     *
     * @return {Promise<void>}
     */
    async revertTreeStructure () {
      // Set dialog to false.
      this.dialog = false
      // Set edited tree.
      this.editedTree = this.$filters.clone(this.tree)
    },

    /**
     * Save edited changes.
     *
     * @return {Promise<void>}
     */
    async saveEditedChanges () {
      // Try to get onEdit callback.
      const onEdit = this.tree?.onEdit || null
      // Check if handler is instance of function.
      if (onEdit instanceof Function) {
        // Call handler and inject active item.
        await onEdit(this.editedTree?.items)
        // Stop edit mode.
        await this.stopEditMode()
      }

      // Set dialog to false.
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .treeview-edit-dialog .treeview .dropable-layer-not-editable {
  cursor: not-allowed !important;
}
</style>
